import request from '@/utils/request'

//提示查询
export function investMsg() {
    return request.post("/member/events/investMsg")
}

//提示失效
export function investMsgNoticed() {
    return request.post("/member/events/investMsgNoticed")
}